// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"2baff155","161":"f7cc5b6c","438":"2f16c8de","763":"8c5e7c4a","960":"cf1a2afc","970":"1b3ee7d7"}[chunkId] + ".chunk.js";
};